// How much of a pack has stuck, as a quiet little ring.
export const MasteryRing = ({ done, total }) => {
  const pct = total ? Math.round((done / total) * 100) : 0;
  const r = 9;
  const c = 2 * Math.PI * r;
  return (
    <span className="inline-flex items-center gap-1.5" title={`${done} of ${total} mastered`}>
      <svg width="24" height="24" viewBox="0 0 24 24" className="-rotate-90">
        <circle cx="12" cy="12" r={r} fill="none" stroke="currentColor" strokeWidth="3" className="text-white/10" />
        <circle
          cx="12" cy="12" r={r} fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"
          className="text-forest" strokeDasharray={c} strokeDashoffset={c - (c * pct) / 100}
        />
      </svg>
      <span className="text-[10px] font-semibold text-ink-soft">{pct}%</span>
    </span>
  );
};

